module.exports = __webpack_public_path__ + "img/riwayat@2x.7406994b.png";